export default {
  props: {
    color: {
      type: Object,
      description: 'Cores da plataforma',
      default: () => ({
        primary: '#5e72e4',
        secondary: '#fff',
      }),
    },
  },
  data() {
    return {
      theme: {
        text: '#47525d',
        link: '#5e72e4',
        border: '#a7a7a7',
        'font-family': '"Roboto", sans-serif',
        'container-width': 'min(90vw, 1140px)',
        ...this.color,
      },
    };
  },
  beforeMount() {
    Object.keys(this.theme).forEach((key) => {
      document.documentElement.style
        .setProperty(`--blog-${key}`, this.theme[key]);
    });
  },
};
